/* eslint-disable import/no-cycle */
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { AppState } from "../store/store.type";
import { Branch } from "Utilities/types";


export interface coordinates {
	latitude: number | null;
	longitude: number | null;
}

// export interface km {
// 	km: number | null
// }

interface ILocation {
	hasLocationPermission: boolean;
	address: string | null;
	coordinates: coordinates | null;
	branch: Branch | null;
	distanceFromBranch: number | null;
}

const initialState = {
	hasLocationPermission: false,
	address: null,
	coordinates: null,
	branch: null,
	distanceFromBranch: null,
	// km: null
};

export const locationSlice = createSlice({
	name: "location",
	initialState,
	reducers: {
		setPermission: (state: ILocation, action: PayloadAction<boolean>) => {
			state.hasLocationPermission = action.payload;
		},
		setUserAddress: (state: ILocation, action: PayloadAction<string>) => {
			state.address = action.payload;
		},
		setCoordinates: (state: ILocation, action: PayloadAction<coordinates>) => {
			state.coordinates = action.payload;
		},
		setBranch: (state: ILocation, action: PayloadAction<Branch>) => {
			state.branch = action.payload;
		},
		setDistanceFromBranch: (state: ILocation, action: PayloadAction<number>) => {
			// console.log(action.payload)
			state.distanceFromBranch = action.payload;
		},
		resetDistanceFromBranch: (state: ILocation) => {
			state.distanceFromBranch = null;
		},




	},
});

export const { setPermission, setUserAddress, setCoordinates, setBranch, setDistanceFromBranch, resetDistanceFromBranch, } = locationSlice.actions;

// Selectors
export const selectBranch = (state: AppState) => state.location.branch;
export const selectPermission = (state: AppState) => state.location.hasLocationPermission;
export const selectUserAddress = (state: AppState) => state.location.address;
export const selectCoordinates = (state: AppState) => state.location.coordinates;
export const selectDistantFromBranch = (state: AppState) => state.location.distanceFromBranch;
// export const selectKm = (state: AppState) => state.location.distanceFromBranch;


export default locationSlice.reducer;
